import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { financialModelingPrepApiKey } from '../keys';

export default function useRevenueSegment(ticker) {
  const [revenueSegment, setRevenueSegment] = useState([]);

  useEffect(() => {
    const fetchRevenueSegment = async () => {
      try {
        const responseMetric = await axios.get(
          `https://financialmodelingprep.com/api/v4/revenue-product-segmentation?symbol=${ticker}&structure=flat&period=annual&apikey=${financialModelingPrepApiKey}`
        );
        const data = responseMetric?.data
        setRevenueSegment(data);
      } catch (error) {
        console.error(error);
      }
    };

    if (ticker) {
      fetchRevenueSegment();
    }
  }, [ticker]);

  return { revenueSegment };
}
